'use strict';

const {createEnum} = require('./enum');

// Simple enum for device types.
module.exports = createEnum('mobile', 'tablet', 'desktop');



// WEBPACK FOOTER //
// ./assets/js/global/utils/deviceTypeEnum.es.js